import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PrefixDeleteModal from './PrefixDeleteModal';

const StudentHeader = ({ 
  tenantId, 
  activeStudentCount, 
  totalStudentCount, 
  inactiveStudentCount, 
  prefix,
  prefixInput,
  setPrefixInput,
  prefixError,
  prefixLoading,
  addPrefix,
  deletePrefix,
  updatePrefix,
  isEditingPrefix,
  setIsEditingPrefix,
  usnPrefix,
  usnPrefixInput,
  setUsnPrefixInput,
  usnPrefixError,
  usnPrefixLoading,
  addUsnPrefix,
  deleteUsnPrefix,
  updateUsnPrefix,
  isEditingUsnPrefix,
  setIsEditingUsnPrefix
}) => {
    const handleAddUsnPrefix = async () => {
      await addUsnPrefix();
    };

    const handleUpdateUsnPrefix = async () => {
      await updateUsnPrefix(usnPrefixInput);
      setIsEditingUsnPrefix(false);
    };


    // Modal state for prefix deletion
    const [showDeletePrefixModal, setShowDeletePrefixModal] = useState(false);
    const [showDeleteUsnPrefixModal, setShowDeleteUsnPrefixModal] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);

    const handleDeleteUsnPrefix = () => {
      setShowDeleteUsnPrefixModal(true);
    };

    const handleCancelUsnEdit = () => {
      setIsEditingUsnPrefix(false);
      setUsnPrefixInput(usnPrefix);
    };
  const navigate = useNavigate();

  const handleAddPrefix = async () => {
    await addPrefix();
  };

  const handleUpdatePrefix = async () => {
    await updatePrefix(prefixInput);
    setIsEditingPrefix(false);
  };

  const handleDeletePrefix = () => {
    setShowDeletePrefixModal(true);
  };

  const handleCancelEdit = () => {
    setIsEditingPrefix(false);
    setPrefixInput(prefix);
  };

  return (
    <div className="mb-6">
      {/* Admission Prefix Delete Modal */}
      <PrefixDeleteModal
        open={showDeletePrefixModal}
        onClose={() => setShowDeletePrefixModal(false)}
        onConfirm={async () => {
          setDeleteLoading(true);
          await deletePrefix();
          setDeleteLoading(false);
          setShowDeletePrefixModal(false);
        }}
        loading={deleteLoading}
        type="Admission"
      />
      {/* USN Prefix Delete Modal */}
      <PrefixDeleteModal
        open={showDeleteUsnPrefixModal}
        onClose={() => setShowDeleteUsnPrefixModal(false)}
        onConfirm={async () => {
          setDeleteLoading(true);
          await deleteUsnPrefix();
          setDeleteLoading(false);
          setShowDeleteUsnPrefixModal(false);
        }}
        loading={deleteLoading}
        type="USN"
      />
      {/* Main Header Row */}
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-4">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center px-3 py-2 bg-white border border-gray-200 rounded-lg shadow-xs text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200"
          >
            <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back
          </button>
          <div className="h-4 w-0.5 bg-gray-300"></div>
          <div>
            <h1 className="text-xl font-bold text-gray-900">Student Management</h1>
            <p className="text-gray-500 text-sm mt-0.5">Manage student records efficiently</p>
          </div>
        </div>

        {/* Compact Statistics */}
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <div className="flex items-center gap-1.5">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span className="font-medium text-gray-900">{activeStudentCount}</span>
              <span>Active</span>
            </div>
            <div className="mx-2 text-gray-300">•</div>
            <div className="flex items-center gap-1.5">
              <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
              <span className="font-medium text-gray-900">{inactiveStudentCount}</span>
              <span>Inactive</span>
            </div>
            <div className="mx-2 text-gray-300">•</div>
            <div className="flex items-center gap-1.5">
              <span className="font-medium text-gray-900">{totalStudentCount}</span>
              <span>Total</span>
            </div>
          </div>
        </div>
      </div>

      {/* Compact Prefix Section */}
      <div className="bg-white rounded-xl border border-gray-200 p-4 mb-4">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div className="flex flex-col gap-2 w-full">
            {/* Admission Prefix */}
            <div className="flex items-center gap-3 mb-2">
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                </svg>
                <span className="text-sm font-medium text-gray-700">Admission Prefix</span>
              </div>
              {prefixLoading ? (
                <div className="animate-pulse h-8 w-20 bg-gray-200 rounded-lg"></div>
              ) : prefix ? (
                <div className="flex items-center gap-2">
                  <span className="font-mono bg-blue-50 text-blue-700 px-3 py-1.5 rounded-lg border border-blue-200 text-sm font-bold">
                    {prefix}
                  </span>
                  {isEditingPrefix ? (
                    <div className="flex items-center gap-2">
                      <input
                        value={prefixInput}
                        onChange={e => {
                          const val = e.target.value.toUpperCase().slice(0, 4);
                          setPrefixInput(val);
                        }}
                        placeholder="Enter prefix"
                        maxLength={4}
                        className="w-20 px-3 py-1.5 border border-gray-300 rounded-lg uppercase font-mono tracking-wider text-sm font-bold focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                      />
                      <div className="flex gap-1">
                        <button
                          onClick={handleUpdatePrefix}
                          disabled={prefixLoading}
                          className="p-1.5 bg-green-500 hover:bg-green-600 text-white rounded-lg transition-colors duration-200 shadow-sm"
                          title="Save"
                        >
                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                        </button>
                        <button
                          onClick={handleCancelEdit}
                          disabled={prefixLoading}
                          className="p-1.5 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg transition-colors duration-200"
                          title="Cancel"
                        >
                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center gap-1">
                      <button
                        onClick={() => { 
                          setIsEditingPrefix(true); 
                          setPrefixInput(prefix); 
                        }}
                        className="p-1.5 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors duration-200 shadow-sm"
                        title="Edit prefix"
                      >
                        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                      <button
                        onClick={handleDeletePrefix}
                        className="p-1.5 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors duration-200 shadow-sm"
                        title="Delete prefix"
                      >
                        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <div className="flex items-center gap-2">
                  <input
                    value={prefixInput}
                    onChange={e => {
                      const val = e.target.value.toUpperCase().slice(0, 4);
                      setPrefixInput(val);
                    }}
                    placeholder="ABCD"
                    maxLength={4}
                    className="w-20 px-3 py-1.5 border border-gray-300 rounded-lg uppercase font-mono tracking-wider text-sm font-bold focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                  />
                  <button
                    onClick={handleAddPrefix}
                    disabled={prefixLoading || !(prefixInput && prefixInput.trim())}
                    className="p-1.5 bg-green-500 hover:bg-green-600 text-white rounded-lg transition-colors duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                    title="Save prefix"
                  >
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </button>
                </div>
              )}
            </div>
            {prefixError && (
              <div className="sm:text-right">
                <p className="text-xs text-red-600 bg-red-50 px-2 py-1 rounded border border-red-200">
                  {prefixError}
                </p>
              </div>
            )}
            {/* Helper Text */}
            {!prefix && !prefixError && (
              <p className="text-xs text-gray-500 mt-2">
                Set a 1-4 letter prefix for admission numbers
              </p>
            )}
            {/* USN Prefix */}
            <div className="flex items-center gap-3 mt-4">
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 01-8 0" />
                </svg>
                <span className="text-sm font-medium text-gray-700">USN Prefix</span>
              </div>
              {usnPrefixLoading ? (
                <div className="animate-pulse h-8 w-20 bg-gray-200 rounded-lg"></div>
              ) : usnPrefix ? (
                <div className="flex items-center gap-2">
                  <span className="font-mono bg-purple-50 text-purple-700 px-3 py-1.5 rounded-lg border border-purple-200 text-sm font-bold">
                    {usnPrefix}
                  </span>
                  {isEditingUsnPrefix ? (
                    <div className="flex items-center gap-2">
                      <input
                        value={usnPrefixInput}
                        onChange={e => {
                          const val = e.target.value.toUpperCase().slice(0, 4);
                          setUsnPrefixInput(val);
                        }}
                        placeholder="Enter USN prefix"
                        maxLength={4}
                        className="w-28 px-3 py-1.5 border border-gray-300 rounded-lg uppercase font-mono tracking-wider text-sm font-bold focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-colors duration-200"
                      />
                      <div className="flex gap-1">
                        <button
                          onClick={handleUpdateUsnPrefix}
                          disabled={usnPrefixLoading}
                          className="p-1.5 bg-green-500 hover:bg-green-600 text-white rounded-lg transition-colors duration-200 shadow-sm"
                          title="Save"
                        >
                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                        </button>
                        <button
                          onClick={handleCancelUsnEdit}
                          disabled={usnPrefixLoading}
                          className="p-1.5 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg transition-colors duration-200"
                          title="Cancel"
                        >
                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center gap-1">
                      <button
                        onClick={() => { 
                          setIsEditingUsnPrefix(true); 
                          setUsnPrefixInput(usnPrefix); 
                        }}
                        className="p-1.5 bg-purple-500 hover:bg-purple-600 text-white rounded-lg transition-colors duration-200 shadow-sm"
                        title="Edit USN prefix"
                      >
                        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                      <button
                        onClick={handleDeleteUsnPrefix}
                        className="p-1.5 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors duration-200 shadow-sm"
                        title="Delete USN prefix"
                      >
                        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <div className="flex items-center gap-2">
                  <input
                    value={usnPrefixInput}
                    onChange={e => {
                      const val = e.target.value.toUpperCase().slice(0, 4);
                      setUsnPrefixInput(val);
                    }}
                    placeholder="USNPREFIX"
                    maxLength={4}
                    className="w-28 px-3 py-1.5 border border-gray-300 rounded-lg uppercase font-mono tracking-wider text-sm font-bold focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-colors duration-200"
                  />
                  <button
                    onClick={handleAddUsnPrefix}
                    disabled={usnPrefixLoading || !(usnPrefixInput && usnPrefixInput.trim())}
                    className="p-1.5 bg-green-500 hover:bg-green-600 text-white rounded-lg transition-colors duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                    title="Save USN prefix"
                  >
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </button>
                </div>
              )}
            </div>
            {usnPrefixError && (
              <div className="sm:text-right">
                <p className="text-xs text-red-600 bg-red-50 px-2 py-1 rounded border border-red-200">
                  {usnPrefixError}
                </p>
              </div>
            )}
            {/* Helper Text */}
            {!usnPrefix && !usnPrefixError && (
              <p className="text-xs text-gray-500 mt-2">
                Set a 1-4 character prefix for USN numbers
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Progress Bar for Active/Inactive Ratio */}
      {totalStudentCount > 0 && (
        <div className="bg-white rounded-xl border border-gray-200 p-4">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium text-gray-700">Student Status Distribution</span>
            <span className="text-xs text-gray-500">
              {Math.round((activeStudentCount / totalStudentCount) * 100)}% Active
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="bg-gradient-to-r from-green-500 to-emerald-600 h-2 rounded-full transition-all duration-500 ease-out"
              style={{ width: `${(activeStudentCount / totalStudentCount) * 100}%` }}
            ></div>
          </div>
          <div className="flex justify-between text-xs text-gray-500 mt-1">
            <span>{activeStudentCount} active students</span>
            <span>{inactiveStudentCount} inactive students</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentHeader;